import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { OBJECT_NAME_RULE, EMAIL_RULE, MOBILE_NUMBER_RULE, FORM_SELECT_RULE } from "../../../utils/validation-utils";
import IdNameModel from "../../../models/common/IdNameModel";
import AddProfilesRequestModel from "../../../models/company/addProfiles/request/AddProfilesRequestModel";
import { RoleEnum } from "../../../models/enums/RoleEnum";
import { useAppSelector } from "../../../context-store";
import toasterUtils from "../../../utils/toaster-utils";
import { Autocomplete, Button, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import { GuidEnum } from "../../../models/enums/GuidEnum";

interface AddCandidateProps {
    objAddProfile: AddProfilesRequestModel;
    recruiterId: string;
    vendorList: IdNameModel[];
    onCloseAddProfile: () => void;
    onAddProfileSave: (objAddProfile: AddProfilesRequestModel, resume: any) => void;
}

const AddCandidateComponent = (props: AddCandidateProps) => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [resume, setResume] = useState<any>();
    const {
        register,
        control,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<AddProfilesRequestModel>({
        mode: "onChange",
        defaultValues: props.objAddProfile
    });

    const onSubmit = (formData: AddProfilesRequestModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        if (resume === undefined || resume === null) {
            toasterUtils.showError("Please upload resume");
            return;
        }
        if (loggedInUser && parseInt(loggedInUser.roleId) === parseInt(RoleEnum.VendorRecruiter.toString())) {
            formData.vendorId = loggedInUser.profileId;
            formData.recruiterId = null;
        } else if (loggedInUser && parseInt(loggedInUser.roleId) === parseInt(RoleEnum.ClientRecruiter.toString())) {
            formData.recruiterId = loggedInUser.profileId;
        } else {
            formData.recruiterId = props.recruiterId;
        }
        if (formData.vendorId === undefined || formData.vendorId === null || formData.vendorId === "") {
            formData.vendorId = null;
        }
        if (formData.recruiterId === undefined || formData.recruiterId === null || formData.recruiterId === "") {
            formData.recruiterId = null;
        }
        formData.emailId = formData.userName;
        props.onAddProfileSave(formData, resume);
    };

    const hiddenFileInput: any = React.useRef();
    const browseFileHandler = (event: any) => {
        event.preventDefault();
        hiddenFileInput.current.click();
    };

    const clearFile = () => {
        hiddenFileInput.current.value = "";
    };

    function uploadCandidateResume(e: any): void {
        setResume(e);
    };

    return (
        <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.name}>
                        <TextField label="Name" size="small" {...register("name", OBJECT_NAME_RULE)} error={!!errors.name}
                            helperText={errors.name?.message} autoComplete="off" required />
                    </FormControl>
                </div>
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.userName}>
                        <TextField type="email" label="Email Id / UserName" size="small" {...register("userName", EMAIL_RULE)} error={!!errors.userName}
                            helperText={errors.userName?.message} autoComplete="off" disabled={props.objAddProfile.userId !== GuidEnum.Empty} required />
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.mobileNumber}>
                        <TextField type="text" label="Mobile Number" size="small" {...register("mobileNumber", MOBILE_NUMBER_RULE)} error={!!errors.mobileNumber}
                            helperText={errors.mobileNumber?.message} autoComplete="off" required />
                    </FormControl>
                </div>
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal">
                        <InputLabel shrink>Resume <span className="required">*</span></InputLabel>
                        <Button variant="outlined" component="label" size="small" fullWidth sx={{ mt: 1 }}>
                            Upload Resume
                            <input type="file" hidden ref={hiddenFileInput} onChange={uploadCandidateResume} accept=".doc,.docx,application/pdf" />
                        </Button>
                        {resume && resume.target && resume.target.files && resume.target.files.length > 0 &&
                            <Typography component="span" variant="body2" color="text.secondary">{resume.target.files[0].name}</Typography>
                        }
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <Controller name="vendorId" control={control} defaultValue=""
                        render={({ field }) => (
                            <Autocomplete {...field} value={props.vendorList.find(x => x.guId === field.value) || null} disabled={Number(loggedInUser?.roleId) === parseInt(RoleEnum.VendorRecruiter.toString())}
                                onChange={(_, newValue) => field.onChange(newValue ? newValue.guId : GuidEnum.Empty)} options={props.vendorList} getOptionLabel={(option) => option.name || ""}
                                renderInput={(params) => (
                                    <TextField {...params} label="Vendor" size="small" margin="normal" fullWidth error={!!errors.vendorId} helperText={errors.vendorId?.message} />
                                )}
                                isOptionEqualToValue={(option, value) => option.guId === value.guId}
                            />
                        )}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 text-end mt-2">
                    <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                        Save
                    </Button>
                    <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={props.onCloseAddProfile}>
                        Close
                    </Button>
                </div>
            </div>
        </form>
    );
};
export default AddCandidateComponent;